'use strict';

var _classCallCheck = require("/home/runner/work/smaug/smaug/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/smaug/smaug/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/runner/work/smaug/smaug/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/smaug/smaug/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/runner/work/smaug/smaug/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var crypto = require('crypto');

var Transform = require('stream').Transform;

var StreamHash =
/*#__PURE__*/
function (_Transform) {
  _inherits(StreamHash, _Transform);

  function StreamHash(attachment, algo) {
    var _this;

    _classCallCheck(this, StreamHash);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StreamHash).call(this));
    _this.attachment = attachment;
    _this.algo = (algo || 'md5').toLowerCase();
    _this.hash = crypto.createHash(algo);
    _this.byteCount = 0;
    return _this;
  }

  _createClass(StreamHash, [{
    key: "_transform",
    value: function _transform(chunk, encoding, done) {
      this.hash.update(chunk);
      this.byteCount += chunk.length;
      done(null, chunk);
    }
  }, {
    key: "_flush",
    value: function _flush(done) {
      this.attachment.checksum = this.hash.digest('hex');
      this.attachment.size = this.byteCount;
      done();
    }
  }]);

  return StreamHash;
}(Transform);

module.exports = StreamHash;